<template>
  <div>
    <v-row class="mt-2" v-if="loadingTotalizers">
      <v-col cols="12" sm="4" md="4" lg="4" v-for="i in 3" :key="i">
        <v-skeleton-loader type="list-item-three-line" class="mb-3"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="mt-2" v-if="!!totalizadores && !loadingTotalizers">
      <v-col cols="12" sm="4" md="4" lg="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row align="center">
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{totalizadores.oportunidades_total}}</div>
              <div class="text-h3">Oportunidades</div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area_medium" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>query_stats</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row align="center">
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(totalizadores.valor_total)}}</div>
              <div class="text-h3">Total de oportunidades perdidas</div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area_medium" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>currency_exchange</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row align="center">
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{$root.Formatter.floatToMoney(totalizadores.ticket_medio)}}</div>
              <div class="text-h3">Ticket médio</div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area_medium" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>local_activity</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Api from '@API'

export default {
  data () {
    return {
      loadingTotalizers: false,
      totalizadores: null
    }
  },
  methods: {
    async getTotalizers () {
      this.loadingTotalizers = true
      await Api.get('oportunidades/totalizador/perdidas')
        .then(res => {
          if (res.data) {
            this.totalizadores = res.data
          }
          this.loadingTotalizers = false
        })
        .catch(err => {
          this.loadingTotalizers = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os totalizadores!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.getTotalizers()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
</style>



// WEBPACK FOOTER //
// src/pages/oportunidades/perdidas/TotalizadorPerdido.vue